import client from './client';

/**
 * Get the current user's daily streak count.
 * @returns {Promise<number>} The current streak value (0 on failure).
 */
export const getMyStreak = async () => {
    try {
        const response = await client.get('/users/streak');
        return response.data.streak;
    } catch (error) {
        return 0;
    }
};

/**
 * Get a user's full profile with friendship-aware data.
 * @param {string} username - The username to look up.
 * @returns {Promise} Profile data including friendship_status and weekly_points (if friends).
 */
export const getUserProfileFull = async (username) => {
    const response = await client.get(`/users/profile/${username}/full`);
    return response.data;
};

export const getUserActivities = async (username, offset = 0, limit = 20) => {
    const response = await client.get(`/users/profile/${username}/activities`, {
        params: { offset, limit },
    });
    return response.data;
};

export const getUserChallenges = async (username) => {
    const response = await client.get(`/users/profile/${username}/challenges`);
    return response.data;
};
